import { get } from 'svelte/store';
import * as db from '$helpers/db';
import { page } from '$app/stores';
import { getCookie, splitCookieForGTM } from '$helpers/CookiesHelper';
import { env } from '$env/dynamic/public';
import { getClientLocation, sendEvent } from 'core-components';

export const submitLead = async (event, attr = {}) => {
  const form = event.target;
  const data = new FormData(form);

  const googleRecaptchaToken = await getCaptchaToken();

  if (data) {
    if (data.get('phone')) {
      data.set(
        'phone',
        (data.get('phone') as string).replaceAll('-', '').trim(),
      );
    }

    const clientLocation = await getClientLocation();
    const hash = data.get('hash');
    const fullName = data.get('fullName');
    const service = data.get('service');
    const phone = data.get('phone');
    const email = data.get('email');
    const comments = data.get('comments');
    const calendar = data.get('calendar');
    const time = data.get('time');
    const budget = data.get('budget');
    const questions = data.get('questions') as string;
    const file = null;
    const gclid = data.get('gclid');
    const appointmentDatetime = data.get('appointmentDatetime');
    const pathUrl = window.location.href;

    const formData = {
      hash,
      fullName,
      service,
      phone,
      calendar,
      email,
      budget,
      time,
      comments,
      file,
      gclid,
      appointmentDatetime,
      pathUrl,
      questions: JSON.parse(questions),
      googleClientId: getCookie('_ga')
        ? splitCookieForGTM(getCookie('_ga'))
        : '',
      clarityId: getCookie('_clck'),
      ip: clientLocation?.ip,
      userAgent: window.navigator.userAgent,
      ...attr,
    };

    const response = await db
      .createLead(
        get(page).data.businessIdentifier,
        get(page).data.pageType,
        formData,
      )
      .finally(() => {
        if (data.get('form_type') === 'exit-form') {
          sendEvent('Submit_Exit_Form', {
            form_name: 'Exit Form',
            user_domain: window.location.hostname,
            lpKey: get(page).data.businessIdentifier,
            email,
          });
        } else {
          sendEvent('Submit_Lead_Form', {
            form_name: get(
              page,
            ).data?.generalSettings?.callToAction?.value.includes('-')
              ? 'Book an Appointment'
              : get(page).data?.generalSettings?.callToAction?.value ||
                'Submit',
            user_domain: window.location.hostname,
            lpKey: get(page).data.businessIdentifier,
            section_clicked: 'form_section',
            set_country:
              get(page).data?.pageData?.index?.websiteData?.locationCountry ||
              'us',
            fullName,
            phone,
            email,
          });
        }
      });
    return response;
  }
};

function getCaptchaToken() {
  if (!window.grecaptcha) return null;

  return new Promise<string>((resolve, reject) => {
    window.grecaptcha.enterprise.ready(async () => {
      try {
        const token = await window.grecaptcha.enterprise.execute(
          env.PUBLIC_GOOGLE_RECAPTCHA,
          { action: 'LEAD_SUBMIT' },
        );
        resolve(token);
      } catch (err) {
        reject(err);
      }
    });
  });
}
